export default "__VITE_ASSET__79937966__"